export default __webpack_public_path__ + "static/media/Q03.2702c42d.jpeg";